// src/utils/mixpanel.js
import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel with your project token
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export const initMixpanel = () => {
    if (MIXPANEL_TOKEN) {
        mixpanel.init(MIXPANEL_TOKEN, {
            track_pageview: true,
            persistence: 'localStorage',
        });
    }
};

// Track events
export const trackEvent = (eventName, properties = {}) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.track(eventName, properties);
    }
};

// Identify users
export const identifyUser = (userId, userProperties = {}) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.identify(userId);
        mixpanel.people.set(userProperties);
    }
};

// Set user properties
export const setUserProperties = (properties) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.people.set(properties);
    }
};

// Track page views
export const trackPageView = (pageName) => {
    if (MIXPANEL_TOKEN) {
        mixpanel.track('Page View', { page: pageName });
    }
};

// Reset user (on logout)
export const resetMixpanel = () => {
    if (MIXPANEL_TOKEN) {
        mixpanel.reset();
    }
};

export default mixpanel;